import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'

import { LayoutAuth } from 'Components/Layout/Auth'
import { userLogin } from 'Reducers/Auth/actions'
import { LoginForm } from 'Containers/Form/Login'
import { authorization } from 'Module/Auth/Auth'
import { BackgroundLogo } from 'Components/Sidebar/BackgroundLogo'

import { PATHS } from 'Config/Routing/paths'
class Login extends Component {
  /**
   * Render component
   * @returns XML
   */
  render() {
    return (
      <LayoutAuth>
        {this.checkLogin()}
        <Col xs={12} md={6}>
          <BackgroundLogo />
        </Col>
        <Col xs={12} md={6}>
          <LoginForm
            formSubmitting={this.props.formSubmitting}
            errorMessage={this.props.errorMessage}
            onSubmit={this.onSubmit}
          />
        </Col>
      </LayoutAuth>
    )
  }

  /**
   * Check if user is login
   * @returns JSX.Element | null
   */
  checkLogin() {
    const { from } = this.props.location.state || {
      from: { pathname: PATHS.main.dashboard },
    }

    return authorization.isLogged() ? <Redirect to={from} /> : null
  }

  /**
   * Submit form (login user)
   * @param values
   */
  onSubmit = values => {
    this.props.userLogin(values.username, values.password)
  }
}

Login.propTypes = {
  userLogin: PropTypes.func.isRequired,
  inputs: PropTypes.shape({
    username: PropTypes.string,
    password: PropTypes.string,
  }),
  errorMessage: PropTypes.string,
}

const mapStateToProps = state => ({
  user: state.auth.user,
  inputs: state.auth.inputs,
  formSubmitting: state.auth.formSubmitting,
  errorMessage: state.auth.errorMessage,
})

export default connect(
  mapStateToProps,
  {
    userLogin,
  },
)(Login)



// WEBPACK FOOTER //
// ./src/Containers/Auth/Login/index.js